import { render, staticRenderFns } from "./PriceListLight.vue?vue&type=template&id=359571d6&scoped=true"
import script from "./PriceListLight.vue?vue&type=script&lang=js"
export * from "./PriceListLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359571d6",
  null
  
)

export default component.exports